import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SiteShell from "../site/SiteShell";

export default function LegalPage({ title, sections }) {
  return (
    <SiteShell>
      <section className="pt-36 pb-24 bg-white">
        <div className="vw-container max-w-4xl">
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--vw-blue)] hover:text-[var(--vw-blue-dark)] mb-8" data-testid="legal-back-link">
            <ArrowLeft size={16}/> Back to home
          </Link>
          <div className="vw-overline mb-4">Verified Workforce</div>
          <h1 className="font-display text-4xl lg:text-6xl font-semibold text-[var(--vw-navy)] tracking-tight leading-[1.02]">
            {title}
          </h1>
          <div className="mt-10 space-y-8 text-[var(--vw-charcoal)] leading-relaxed">
            {sections.map((s, i) => (
              <section key={i}>
                {s.heading && (
                  <h2 className="font-display text-xl font-semibold text-[var(--vw-navy)] mb-3">{s.heading}</h2>
                )}
                <p>{s.body}</p>
              </section>
            ))}
          </div>
        </div>
      </section>
    </SiteShell>
  );
}
